import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-theme",
  "use": "icon-theme-usage",
  "viewBox": "0 0 1072 579",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1072 579\" id=\"icon-theme\">\r\n  <g transform=\"matrix(1 0 0 1 -30 -57 )\">\r\n    <path d=\"M 30 57  L 1102 57  L 1102 636  L 30 636  L 30 57  \" fill-rule=\"nonzero\" fill=\"#cccccc\" stroke=\"none\" />\r\n    <path d=\"M 71 98  L 1061 98  L 1061 595  L 71 595  L 71 98  \" fill-rule=\"nonzero\" fill=\"#ffffff\" stroke=\"none\" />\r\n    <path d=\"M 630.865 230.7  C 606.547 230.7  587.44 211.593  587.44 187.275  C 587.44 162.957  606.547 143.85  630.865 143.85  C 655.183 143.85  674.29 162.957  674.29 187.275  C 674.29 211.593  655.183 230.7  630.865 230.7  \" fill-rule=\"nonzero\" fill=\"#cccccc\" stroke=\"none\" />\r\n    <path d=\"M 86 581  L 86 323.6  L 326.25 206.6  L 662.6 429.336567164179  L 854.8 276.8  L 1047 429.336567164179  L 1047 581  L 86 581  \" fill-rule=\"nonzero\" fill=\"#169bd5\" stroke=\"none\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/theme.svg
// module id = hdtf
// module chunks = 0